// extracted by mini-css-extract-plugin
module.exports = {"slide":"PurchasePage_slide_1GwV8","slide-reverse":"PurchasePage_slide-reverse_3qJSc","table":"PurchasePage_table_qOOv2","header":"PurchasePage_header_3E4Ks"};